// extracted by mini-css-extract-plugin
export var details = "line-item-module--details--5+LxE";
export var imagee = "line-item-module--imagee--4Pb3V";
export var priceColumn = "line-item-module--priceColumn--4fOMG";
export var remove = "line-item-module--remove--d53MQ";
export var title = "line-item-module--title--5L2ju";
export var totals = "line-item-module--totals--aZEC6";
export var variant = "line-item-module--variant--K9VDH";